import React, { useState } from 'react';
import { 
  Database,
  Link,
  RefreshCw,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Clock,
  Settings,
  Eye,
  Trash2,
  Download,
  Plus,
  Edit,
  Save,
  X,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  Users,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Link as LinkIcon,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  Copy,
  Globe,
  Users2,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart,
  AreaChart,
  TrendingUp,
  TrendingDown,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon2,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon2,
  CheckCircle as CheckCircleIcon2,
  XCircle as XCircleIcon2,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon2,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const ERPIntegration = () => {
  const [activeTab, setActiveTab] = useState('connections');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for ERP connections
  const [erpConnections, setErpConnections] = useState([
    {
      id: 'ERP-001',
      erpSystem: 'SAP S/4HANA',
      connectionName: 'SAP Production',
      status: 'Connected',
      lastSync: '2024-02-15 14:30:00',
      syncFrequency: 'Real-time',
      dataTypes: ['Assets', 'Contracts', 'Financial'],
      recordCount: 125000,
      successRate: 99.8,
      responseTime: '45ms',
      serverUrl: 'https://sap-prod.company.com',
      version: '2023.1',
      isActive: true,
      tags: ['sap', 'production', 'critical'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 234,
      downloadCount: 15,
      aiInsights: ['Connection stable', 'High success rate', 'Consider optimizing sync frequency'],
      keyMetrics: {
        dailySyncs: 1440,
        errorRate: '0.2%',
        averageResponseTime: '45ms',
        dataVolume: '2.5GB'
      },
      alerts: ['Sync frequency high'],
      performanceScore: 94.2
    },
    {
      id: 'ERP-002',
      erpSystem: 'Oracle NetSuite',
      connectionName: 'NetSuite Financial',
      status: 'Connected',
      lastSync: '2024-02-15 14:25:00',
      syncFrequency: 'Hourly',
      dataTypes: ['Financial', 'Contracts'],
      recordCount: 45000,
      successRate: 98.5,
      responseTime: '120ms',
      serverUrl: 'https://netsuite.company.com',
      version: '2023.2',
      isActive: true,
      tags: ['netsuite', 'financial', 'hourly'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 156,
      downloadCount: 8,
      aiInsights: ['Good performance', 'Minor sync delays', 'Consider real-time for critical data'],
      keyMetrics: {
        dailySyncs: 24,
        errorRate: '1.5%',
        averageResponseTime: '120ms',
        dataVolume: '850MB'
      },
      alerts: ['Response time above threshold'],
      performanceScore: 87.6
    },
    {
      id: 'ERP-003',
      erpSystem: 'Microsoft Dynamics 365',
      connectionName: 'Dynamics CRM',
      status: 'Disconnected',
      lastSync: '2024-02-15 10:15:00',
      syncFrequency: 'Daily',
      dataTypes: ['Contracts', 'Assets'],
      recordCount: 23000,
      successRate: 95.2,
      responseTime: '200ms',
      serverUrl: 'https://dynamics.company.com',
      version: '2023.1',
      isActive: false,
      tags: ['dynamics', 'crm', 'disconnected'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 89,
      downloadCount: 5,
      aiInsights: ['Connection lost', 'Check network connectivity', 'Authentication may have expired'],
      keyMetrics: {
        dailySyncs: 1,
        errorRate: '4.8%',
        averageResponseTime: '200ms',
        dataVolume: '320MB'
      },
      alerts: ['Connection lost', 'Authentication failed'],
      performanceScore: 45.8
    }
  ]);

  // Mock data for data sync logs
  const [syncLogs, setSyncLogs] = useState([
    {
      id: 'SYNC-001',
      erpSystem: 'SAP S/4HANA',
      syncType: 'Full Sync',
      status: 'Completed',
      startTime: '2024-02-15 14:00:00',
      endTime: '2024-02-15 14:05:00',
      duration: '5 minutes',
      recordsProcessed: 1250,
      recordsSuccessful: 1248,
      recordsFailed: 2,
      dataSize: '45MB',
      errorMessage: null,
      createdBy: 'System',
      isActive: true,
      tags: ['sap', 'full-sync', 'completed'],
      isBookmarked: false,
      isStarred: false,
      viewCount: 12,
      downloadCount: 2,
      aiInsights: ['Sync completed successfully', '2 records failed - check data quality', 'Performance within expected range'],
      keyMetrics: {
        successRate: '99.8%',
        averageRecordTime: '240ms',
        throughput: '4.2 records/sec',
        errorRate: '0.2%'
      },
      alerts: ['2 records failed'],
      performanceScore: 98.4
    },
    {
      id: 'SYNC-002',
      erpSystem: 'Oracle NetSuite',
      syncType: 'Incremental Sync',
      status: 'Failed',
      startTime: '2024-02-15 13:30:00',
      endTime: '2024-02-15 13:35:00',
      duration: '5 minutes',
      recordsProcessed: 450,
      recordsSuccessful: 0,
      recordsFailed: 450,
      dataSize: '12MB',
      errorMessage: 'Authentication timeout - invalid credentials',
      createdBy: 'System',
      isActive: true,
      tags: ['netsuite', 'incremental', 'failed'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 8,
      downloadCount: 1,
      aiInsights: ['Authentication failure', 'Check credentials', 'Network connectivity issues possible'],
      keyMetrics: {
        successRate: '0%',
        averageRecordTime: 'N/A',
        throughput: '0 records/sec',
        errorRate: '100%'
      },
      alerts: ['Authentication failed', 'All records failed'],
      performanceScore: 0
    }
  ]);

  // Calculate statistics
  const stats = {
    totalConnections: erpConnections.length,
    activeConnections: erpConnections.filter(c => c.status === 'Connected').length,
    disconnectedConnections: erpConnections.filter(c => c.status === 'Disconnected').length,
    totalRecords: erpConnections.reduce((sum, conn) => sum + conn.recordCount, 0),
    averageSuccessRate: erpConnections.reduce((sum, conn) => sum + conn.successRate, 0) / erpConnections.length,
    totalSyncLogs: syncLogs.length,
    successfulSyncs: syncLogs.filter(s => s.status === 'Completed').length,
    failedSyncs: syncLogs.filter(s => s.status === 'Failed').length,
    averageResponseTime: erpConnections.reduce((sum, conn) => {
      const responseTime = parseFloat(conn.responseTime.replace('ms', ''));
      return sum + responseTime;
    }, 0) / erpConnections.length
  };

  const tabs = [
    { id: 'connections', label: 'ERP Connections' },
    { id: 'sync-logs', label: 'Sync Logs' },
    { id: 'data-mapping', label: 'Data Mapping' },
    { id: 'configuration', label: 'Configuration' }
  ];

  // Define columns for ERP Connections DataTable
  const erpConnectionsColumns = [
    {
      key: 'erpSystem',
      label: 'ERP System Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.connectionName} • v{row.version}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '120px',
      render: (status) => {
        const statusConfig = {
          'Connected': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Disconnected': { color: '#ef4444', bg: '#fee2e2', icon: <XCircle size={14} /> },
          'Connecting': { color: '#f59e0b', bg: '#fef3c7', icon: <Clock size={14} /> },
          'Error': { color: '#ef4444', bg: '#fee2e2', icon: <AlertTriangle size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Connected'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'lastSync',
      label: 'Last Sync',
      width: '140px',
      render: (time) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{time}</span>
      )
    },
    {
      key: 'syncFrequency',
      label: 'Sync Frequency',
      width: '120px',
      render: (frequency) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{frequency}</span>
      )
    },
    {
      key: 'recordCount',
      label: 'Records',
      width: '100px',
      render: (count) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>
          {count.toLocaleString()}
        </span>
      )
    },
    {
      key: 'successRate',
      label: 'Success Rate',
      width: '120px',
      render: (rate) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${Math.min(rate, 100)}%`,
              height: '100%',
              backgroundColor: rate >= 95 ? '#10b981' : rate >= 90 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: rate >= 95 ? '#10b981' : rate >= 90 ? '#f59e0b' : '#ef4444' 
          }}>
            {rate.toFixed(1)}%
          </span>
        </div>
      )
    },
    {
      key: 'responseTime',
      label: 'Response Time',
      width: '120px',
      render: (time) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{time}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Report"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Connection"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Sync Logs DataTable
  const syncLogsColumns = [
    {
      key: 'erpSystem',
      label: 'Sync Details',
      width: '250px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.syncType} • {row.startTime}
          </div>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '120px',
      render: (status) => {
        const statusConfig = {
          'Completed': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Failed': { color: '#ef4444', bg: '#fee2e2', icon: <XCircle size={14} /> },
          'In Progress': { color: '#f59e0b', bg: '#fef3c7', icon: <Clock size={14} /> },
          'Pending': { color: '#6b7280', bg: '#f3f4f6', icon: <Clock size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Pending'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'duration',
      label: 'Duration',
      width: '100px',
      render: (duration) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{duration}</span>
      )
    },
    {
      key: 'recordsProcessed',
      label: 'Records',
      width: '120px',
      render: (count) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>
          {count.toLocaleString()}
        </span>
      )
    },
    {
      key: 'recordsSuccessful',
      label: 'Successful',
      width: '100px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: '#10b981' }}>
          {count.toLocaleString()}
        </span>
      )
    },
    {
      key: 'recordsFailed',
      label: 'Failed',
      width: '80px',
      render: (count) => (
        <span style={{ fontWeight: '500', color: count > 0 ? '#ef4444' : '#10b981' }}>
          {count.toLocaleString()}
        </span>
      )
    },
    {
      key: 'dataSize',
      label: 'Data Size',
      width: '100px',
      render: (size) => (
        <span style={{ fontWeight: '500', color: '#1f2937' }}>{size}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Log"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Log"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.erpSystem);
  };

  const handleExport = (item) => {
    setSelectedItem(item);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'connections') {
        setErpConnections(prev => prev.filter(conn => conn.id !== selectedItem.id));
      } else {
        setSyncLogs(prev => prev.filter(log => log.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          ERP Integration
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Connect and synchronize data with enterprise resource planning systems
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'connections' && <Database size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'sync-logs' && <RefreshCw size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'data-mapping' && <Link size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'configuration' && <Settings size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Connections</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalConnections}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeConnections} active, {stats.disconnectedConnections} disconnected
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <Database size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Records</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {(stats.totalRecords / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Synchronized records
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <RefreshCw size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg Success Rate</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageSuccessRate.toFixed(1)}%
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Data synchronization
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <CheckCircle size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Sync Logs</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.totalSyncLogs}
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.successfulSyncs} successful, {stats.failedSyncs} failed
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <FileTextIcon size={20} />
          </div>
        </div>
      </div>

      {/* ERP Connections Tab */}
      {activeTab === 'connections' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={erpConnections}
              columns={erpConnectionsColumns}
              title={`ERP Connections (${erpConnections.length} connections)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Sync Logs Tab */}
      {activeTab === 'sync-logs' && (
        <div>
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={syncLogs}
              columns={syncLogsColumns}
              title={`Sync Logs (${syncLogs.length} logs)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'data-mapping' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Data Mapping Configuration Coming Soon!
        </div>
      )}

      {activeTab === 'configuration' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          ERP Configuration Settings Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Item"
        message={`Are you sure you want to delete "${selectedItem?.erpSystem}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export ERP integration report for "${selectedItem?.erpSystem}"? This will generate a comprehensive report with connection details and sync logs.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default ERPIntegration;
